import { Avatar, Result } from "antd";
import * as React from "react";
import { _T } from "../src/Localization";
import { getAssetUrl } from '../scripts/cdn';
export const NotFound = () => {
    return (React.createElement(Result, { title: "404", subTitle: _T('common.404'), icon: React.createElement(Avatar, { style: { margin: 14 }, size: { xs: 80, sm: 100, md: 140, lg: 200, xl: 250, xxl: 300 }, src: getAssetUrl(require('../images/favicon/favicon-96.png')) }) }));
};
